
import React from 'react';
import { Table, TableBody, TableRow, TableCell } from '@/components/ui/table';
import { Lead, LeadStatus, LeadOutcome } from '../types/LeadTypes';
import DesktopLeadTableRow from './DesktopLeadTableRow';
import LeadExpandedDetails from './LeadExpandedDetails';
import { ScrollArea } from '@/components/ui/scroll-area';
import { calculateTotalMinWidth } from './utils/tableUtils';

interface LeadTableContentProps {
  leads: Lead[];
  openLeads: Record<string, boolean>;
  columnStyles: {
    toggle: string;
    name: string;
    phone: string;
    status: string;
    outcome: string;
    value: string;
    date: string;
  };
  onToggle: (id: string) => void;
  onOpenNameModal: (id: string) => void;
  onStatusChange: (id: string, status: LeadStatus) => void;
  onOutcomeChange: (id: string, outcome: LeadOutcome | null) => void;
  onValueChange: (id: string, value: string) => void;
  onOpenTranscriptModal: (id: string) => void;
}

const LeadTableContent: React.FC<LeadTableContentProps> = ({
  leads,
  openLeads,
  columnStyles,
  onToggle,
  onOpenNameModal,
  onStatusChange,
  onOutcomeChange,
  onValueChange,
  onOpenTranscriptModal
}) => {
  // Get the total minimum width from our utility
  const totalMinWidth = calculateTotalMinWidth();
  
  return (
    <ScrollArea className="h-[400px]">
      <div style={{ minWidth: `${totalMinWidth}px` }}>
        <Table className="table-fixed w-full">
          <TableBody>
            {leads.map(lead => (
              <React.Fragment key={lead.id}>
                <DesktopLeadTableRow
                  lead={lead}
                  isOpen={!!openLeads[lead.id]}
                  columnStyles={columnStyles}
                  onToggle={onToggle}
                  onOpenNameModal={onOpenNameModal}
                  onStatusChange={onStatusChange}
                  onOutcomeChange={onOutcomeChange}
                  onValueChange={onValueChange}
                />
                {openLeads[lead.id] && (
                  <TableRow className="bg-gray-50">
                    <TableCell colSpan={7} className="p-6">
                      <LeadExpandedDetails
                        lead={lead}
                        openTranscriptModal={() => onOpenTranscriptModal(lead.id)}
                      />
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </div>
    </ScrollArea>
  );
};

export default LeadTableContent;
